export default {
    integrations: { 
        vcrm: true ,
        recaptcha: { key: '6Lca4iQaAAAAAC2dC0Dri-A6acm9b41VbsEVdnYs' },
    },
}